import {Api, Method} from "../../api/api";
import {showToast} from "../../toast";

const Selector = {
  TEXT_ELEMENT: `.js-personal-text`,
};

const ValidateType = {
  PHONE: `phone`,
  EMAIL: `email`,
};

class Personal {
  private readonly formElement: HTMLFormElement;
  private readonly actionUrl: string;
  private api = new Api();

  constructor(selector: string) {
    this.formElement = document.querySelector(selector)!;
    this.actionUrl = this.formElement.action;

    this.onFormChange = this.onFormChange.bind(this);
  }

  init() {
    this.formElement.addEventListener(`change`, this.onFormChange);
  }

  private getFormData() {
    return new FormData(this.formElement);
  }

  private getValidateInput(value: string, type: string) {
    switch (type) {
      case ValidateType.EMAIL:
        return value.length ? value.match(/\S+@\S+\.[a-z]+/i) : true;
      case ValidateType.PHONE:
        return value.length
          ? value.match(
            /(^(?!\+.*\(.*\).*--.*$)(?!\+.*\(.*\).*-$)([+0-9][0-9][(0-9]{2}[()0-9][0-9]([)0-9]?)?([0-9]?)?([)-0-9]?)?([-0-9]{0,7})?([0-9]{0,3})?)$)|(^[0-9]{1,4}$)/,
          )
          : true;
      default:
        return true;
    }
  }

  private async post(): Promise<{status: number, answer: string}> {
    return await this.api.customQuery(this.actionUrl, {method: Method.POST, query: this.getFormData()});
  }

  async onFormChange(evt: Event) {
    const target = evt.target as HTMLInputElement;

    if (target.value.length === 0) {
      const textElement: HTMLSpanElement = target.parentElement!.querySelector(Selector.TEXT_ELEMENT)!;
      textElement.textContent = textElement.ariaLabel;
    }

    if (this.getValidateInput(target.value, target.dataset.validateType!)) {
      const {status, answer} = await this.post();

      if (status === 200) {
        const textElement: HTMLSpanElement = target.parentElement!.querySelector(Selector.TEXT_ELEMENT)!;
        textElement.textContent = target.value.length ? target.value : textElement.ariaLabel;
      } else {
        showToast(answer);
      }
    }
  }
}

export {Personal};
